import { SVGProps } from "react";
import { ControllerFieldState } from "react-hook-form";

export enum FieldType {
  Text = 0,
  AreaText = 1,
  TineMCE = 2,
  DateTime = 3,
  Date = 4,
  DragFile = 5,
  UploadFile = 6,
  UploadImage = 7,
  CallbackSelect = 8,
  Select = 9,
  Number = 10,
  RangePicker = 11,
  ColorPicker = 12,
  Switch = 13,
  RequiredComponent = 14,
  MappedField = 15,
  PredefinedComponent = 16,
  UserMappedField = 17,
}

// Input Types
export interface DefaultInputType {
  id?: string;
  label?: string | React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  shape?: "circle" | "squre";
  textColorClassName?: string;
  bgColorClassName?: "primary" | "secondary" | string;
  inputExtraClassNames?: string;
  isError?: boolean;
  fieldState?: ControllerFieldState;
}

export interface TextInputType extends DefaultInputType {
  value?: string | undefined;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  onEnter?: (value: string) => void;
  inputHtmlType?: "text" | "password" | string;
  prefix?: JSX.Element;
  suffix?: JSX.Element;
}

// Form Types
export interface DefaultFormOptions {
  maxLength?: number;
  minLength?: number;
  pattern?: RegExp;
  maxDate?: string;
  minDate?: string;
  max?: number;
  min?: number;
  types?: string[];
  uploadEndPoint?: string;
  upToKB?: number;
}

export interface BaseFormType<TValue> {
  order?: number;
  label?: string;
  placeHolder?: string;
  permission?: string;
  disabled?: boolean;
  required?: boolean;
  value?: TValue | null;
  onChange?: (props: TValue) => void;
}

export interface TextOptions extends DefaultFormOptions {
  maxLength?: number;
  minLength?: number;
  pattern?: RegExp;
}

export interface TextFormType extends BaseFormType<string> {
  fieldType: FieldType.Text;
  fieldOptions: TextOptions;
}

export interface TextAreaOptions extends TextOptions {
  rows?: number;
}

export interface TextAreaFormType extends BaseFormType<string> {
  fieldType: FieldType.AreaText;
  fieldOptions: TextAreaOptions;
}

export interface TinyMCEOptions extends TextOptions {
  height?: number;
}
export interface TinyMCEFormType extends BaseFormType<string> {
  fieldType: FieldType.TineMCE;
  fieldOptions: TinyMCEOptions;
}

export interface DateOptions extends DefaultFormOptions {
  maxDate?: string;
  minDate?: string;
}

export interface DateFormType extends BaseFormType<string> {
  fieldType: FieldType.Date;
  fieldOptions: DateOptions;
}

export interface DateTimeFormType extends BaseFormType<string> {
  fieldType: FieldType.DateTime;
  fieldOptions: DateOptions;
}
export interface SwitchFormType extends BaseFormType<boolean> {
  fieldType: FieldType.Switch;
  fieldOptions?: DefaultFormOptions;
}

export interface UploadFileOptions extends DefaultFormOptions {
  types?: string[];
  uploadEndPoint?: string;
  upToKB?: number;
}

export interface UploadFileFormType extends BaseFormType<string> {
  fieldType: FieldType.UploadFile | FieldType.UploadImage | FieldType.DragFile;
  fieldOptions: UploadFileOptions;
}

export interface NumericOptions extends DefaultFormOptions {
  max?: number;
  min?: number;
}

export interface NumericFormType extends BaseFormType<number> {
  // fieldType: FieldType.Number;
  fieldOptions: NumericOptions;
}

export interface SelectOption {
  label: string | undefined;
  value: string | undefined;
  group?: string;
}
export interface SelectInputOptions extends DefaultFormOptions {
  isMulti?: boolean;
  selectOptions?: SelectOption[];
  withOrder?: boolean;
  allowedPredefinedComponents?: string[];
}
export interface SelectFormTypeV2 extends BaseFormType<SelectOption> {
  fieldType:
    | FieldType.Select
    | FieldType.MappedField
    | FieldType.RequiredComponent
    | FieldType.PredefinedComponent;
  fieldOptions?: SelectInputOptions;
}

export interface IconProps extends SVGProps<SVGSVGElement> {
  width: number;
  height: number;
  color?: string;
}
